module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAYAAABoMT8aAAAAAXNSR0IArs4c6QAAANhJREFUOBG9lFkKwzAMRNPkEl1OE+ipSr+65UY9QvfvHqfuTLBA+CNISohBCIznjS3bqqq5R0ppjTggWrc3RBvEB8HxRTRmCBZrMQF7xMIEyOI3VXkcTUIugoBnHiV+iS3yyeO8guA5lfjscV7C9aGcL7OK78q58zizYLeouIbwmsU/ZHvBsMXavM2hhXDla4udX8AAlNdnL6KCsJixNzAAcRW152AX5T8IQ2I/UR2Ht6Mh9kZSQGINRUHYDyeBSEcGL+3EwJwh0p3Z19bFBRAWtkNsZW5U/gNol7r7yOE5TAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/up.png
// module id = WY0H
// module chunks = 0